import { defineStore } from 'pinia'
import api from '@/api/axios'

const getCustomerId = (customer) => customer?.id || customer?._id?.$oid || customer?._id || null

export const useCustomersStore = defineStore('customers', {
    state: () => ({
        customers: {
            items: [],
            count: 0
        },
        currentCustomer: null,
        pageSize: 20,
    }),
    getters: {
        allCustomers: (state) =>
            state.customers.items.map((customer) => ({
                ...customer,
                id: getCustomerId(customer),
            })),
        countPages: (state) => Math.ceil(state.customers.count / state.pageSize) || 1,
    },

    actions: {
        async getCustomers(page = 1) {
            try {
                const response = await api.get(`/customers?limit=${this.pageSize}&page=${page}`)
                this.customers = response.data
            } catch (error) {
                console.error('Failed to fetch customers:', error)
                throw error
            }
        },

        async getCustomer(id) {
            try {
                const response = await api.get(`/customers/${id}`)
                this.currentCustomer = response.data
            } catch (error) {
                console.error('Failed to fetch customer:', error)
                throw error
            }
        },

        async addCustomer(customerData) {
            try {
                const response = await api.post('/customers', customerData)
                if (!Array.isArray(this.customers.items)) {
                    this.customers.items = []
                }
                this.customers.items.push(response.data)
                this.customers.count += 1
                this.currentCustomer = response.data
                return response.data
            } catch (error) {
                console.error('Failed to add customer:', error)
                throw error
            }
        },

        async updateCustomer(id, customerData) {
            try {
                const response = await api.put(`/customers/${id}`, customerData)
                const index = this.customers.items.findIndex((customer) => String(getCustomerId(customer)) === String(id))
                if (index !== -1) {
                    this.customers.items[index] = response.data
                }
                this.currentCustomer = response.data
                return response.data
            } catch (error) {
                console.error('Failed to update customer:', error)
                throw error
            }
        },
    },
})
